'use client';

import { c as _c } from "react/compiler-runtime";
import type { MenuQuickLink, PrimaryNavigationItem } from '../../types';
import { DesktopMenu } from './desktop-menu';
import { MobileMenu } from './mobile-menu';
import './menu.scss';
type MenuProps = {
  items: PrimaryNavigationItem[];
  quickLinks: MenuQuickLink[];
};
export function Menu(t0) {
  const $ = _c(8);
  const {
    items,
    quickLinks
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = <div className="menu__desktop"><DesktopMenu items={items} /></div>;
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== items || $[3] !== quickLinks) {
    t2 = <div className="menu__mobile"><MobileMenu items={items} quickLinks={quickLinks} /></div>;
    $[2] = items;
    $[3] = quickLinks;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="menu">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}